/*
 * Job Comments Modal (the "Main Comment Modal")
 *
 * Slide-out wrapper that opens from the ASSETS page JOB ACTIONS menu instead of
 * navigating to /job_comments. Renders the shared JobCommentsContent in its
 * "modal" variant; the add/edit-comment form opens as a stacked second modal
 * beside this one (handled inside JobCommentsContent).
 *
 * The action buttons ("+ Add Comment", and "Hospital Rep Signature" for
 * verification jobs) live in this modal's title bar (top-right) so the filter
 * row inside the body can use the full modal width.
 */
import * as React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import {
    setSelectedJobComment,
    toggleEditJobCommentModal,
    toggleJobCommentsModal,
    toggleModalVerificationSignaturePad
} from '../../actions/manageJobCommentsActions';
import { jobTypesIdEnum } from '../../models-enums';
import { IinitialState } from '../../reducers';
import { initialJob, initialJobComment } from '../../reducers/initialState';
import { selectIsJobReadOnly } from '../../reducers/commonSelectors';
import CommonModal from '../common/CommonModal';
import JobCommentsContent from './JobCommentsContent';

const JobCommentsModal: React.FC<RouteComponentProps<any>> = props => {
    const { t } = useTranslation('manageJobComments');
    const dispatch = useDispatch();

    const show = useSelector((state: IinitialState) => state.manageJobComment.showJobCommentsModal);
    const selectedJob = useSelector(
        (state: IinitialState) => state.manageJob.jobsByID[state.manageJob.selectedJob.id] || initialJob
    );

    const isJobReadOnly = useSelector(selectIsJobReadOnly);

    const onHide = () => dispatch(toggleJobCommentsModal());

    const onAddComment = () => {
        dispatch(setSelectedJobComment(initialJobComment));
        dispatch(toggleEditJobCommentModal());
    };

    const title = (
        <div className="job-comments-modal-title-bar">
            <span>{t('bannerTitle')}</span>
            {!isJobReadOnly && (
                <span className="job-comments-modal-title-actions">
                    {selectedJob.jobTypeID === jobTypesIdEnum.verification && (
                        <Button variant="link" onClick={() => dispatch(toggleModalVerificationSignaturePad())}>
                            {t('hospitalRepSignature')}
                        </Button>
                    )}
                    <Button variant="link" onClick={onAddComment}>
                        {t('newJobCommentButton')}
                    </Button>
                </span>
            )}
        </div>
    );

    return (
        <CommonModal className="job-comments-modal" wideModal={true} title={title} show={show} onHide={onHide}>
            <JobCommentsContent variant="modal" {...props} />
        </CommonModal>
    );
};

export default withRouter(JobCommentsModal);
